import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tipos-de-liquidacion-unidad';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones  Unidades
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesUnidades = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Unidad
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionUnidad = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Unidad
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionUnidad = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Unidad
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionUnidad = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Unidad
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionUnidad = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
